const translations: Record<string, string> = {
  'common:siteName': 'Herramientas PDF Gratis',
  'common:nav.home': 'Inicio',
  'common:nav.pdfToWord': 'PDF a Word',
  'common:nav.pdfToExcel': 'PDF a Excel',
  'common:nav.pdfToPpt': 'PDF a PPT',
  'common:nav.imageConvert': 'Convertir Imagen',
  'common:nav.pdfTools': 'Herramientas PDF',
  'common:nav.tutorials': 'Tutoriales',
  'common:nav.faq': 'Preguntas Frecuentes',

  'common:footer.description': 'Las mejores herramientas PDF gratuitas para todas tus necesidades. Sin registro.',
  'common:footer.quickLinks': 'Enlaces Rápidos',
  'common:footer.about': 'Acerca de',
  'common:footer.aboutUs': 'Sobre Nosotros',
  'common:footer.tutorials': 'Tutoriales',
  'common:footer.faq': 'Preguntas Frecuentes',
  'common:footer.privacyPolicy': 'Política de Privacidad',
  'common:footer.subscribe': 'Boletín',
  'common:footer.subscribeNote': 'Recibe los últimos consejos y actualizaciones.',
  'common:footer.subscribePlaceholder': 'Ingresa tu correo',
  'common:footer.subscribeButton': 'Suscribirse',
  'common:footer.subscribing': 'Suscribiendo...',
  'common:footer.subscribeSuccess': '✓ ¡Suscrito exitosamente!',
  'common:footer.subscribeFailed': 'Fallo al suscribirse, intenta de nuevo.',
  'common:footer.subscribeError': 'Error de red, intenta de nuevo.',
  'common:footer.adSpace': 'Espacio Publicitario',
  'common:footer.copyright': '© 2024 Herramientas PDF Gratis. Todos los derechos reservados.',

  'common:features.pdfToDoc': 'PDF a Documentos',
  'common:features.pdfToDocDesc': 'Convierte PDF a Word, Excel, PPT y más formatos editables.',
  'common:features.imageToPdf': 'Imagen a PDF',
  'common:features.imageToPdfDesc': 'Combina múltiples imágenes en un solo archivo PDF fácilmente.',
  'common:features.pdfMerge': 'Combinar y Dividir PDF',
  'common:features.pdfMergeDesc': 'Combina varios PDFs o divide uno en archivos separados.',
  'common:features.startConvert': 'Comenzar Conversión',
  'common:features.useNow': 'Usar Ahora',
  'common:features.mostPopular': 'Más Popular',

  'home:hero.title': 'Herramientas PDF Gratis en Línea',
  'home:hero.subtitle': '¡Convierte, edita y gestiona tus archivos PDF fácilmente. Sin registro, 100% gratis!',
  'home:hero.free': 'Gratis Para Siempre',
  'home:hero.noRegistration': 'Sin Registro',
  'home:hero.secure': 'Seguro y Privado',
  'home:hero.startConverting': 'Comenzar a Convertir',
  'home:hero.viewAllTools': 'Ver Todas las Herramientas',
  'home:hero.stats.users': 'Usuarios Satisfechos',
  'home:hero.stats.conversions': 'Archivos Convertidos',
  'home:hero.stats.rating': 'Calificación de Usuarios',

  'home:allTools.title': 'Todas las Herramientas PDF',
  'home:allTools.subtitle': 'Todo lo que necesitas para trabajar con archivos PDF, completamente gratis.',
  'home:allTools.tryNow': 'Probar Ahora',
  'home:tools.pdfToWord.name': 'PDF a Word',
  'home:tools.pdfToWord.description': 'Convierte PDF a documentos Word editables.',
  'home:tools.pdfToExcel.name': 'PDF a Excel',
  'home:tools.pdfToExcel.description': 'Extrae tablas de PDF a hojas de cálculo Excel.',
  'home:tools.pdfToPpt.name': 'PDF a PPT',
  'home:tools.pdfToPpt.description': 'Transforma PDF en presentaciones PowerPoint.',
  'home:tools.pdfToImage.name': 'PDF a Imagen',
  'home:tools.pdfToImage.description': 'Convierte páginas PDF a imágenes JPG o PNG.',
  'home:tools.imageToPdf.name': 'Imagen a PDF',
  'home:tools.imageToPdf.description': 'Combina imágenes en un solo archivo PDF.',
  'home:tools.mergePdf.name': 'Combinar PDF',
  'home:tools.mergePdf.description': 'Combina múltiples archivos PDF en uno.',
  'home:tools.splitPdf.name': 'Dividir PDF',
  'home:tools.splitPdf.description': 'Extrae páginas de un archivo PDF.',
  'home:tools.compressPdf.name': 'Comprimir PDF',
  'home:tools.compressPdf.description': 'Reduce el tamaño del archivo PDF sin perder calidad.',

  'home:whyUs.title': '¿Por Qué Elegirnos?',
  'home:whyUs.subtitle': 'Ofrecemos las mejores herramientas PDF gratuitas sin cargos ocultos ni registro.',
  'home:whyUs.free.title': '100% Gratis',
  'home:whyUs.free.description': 'Todas las herramientas son completamente gratuitas. Sin cargos ocultos.',
  'home:whyUs.fast.title': 'Ultra Rápido',
  'home:whyUs.fast.description': 'Nuestros servidores procesan tus archivos en segundos.',
  'home:whyUs.secure.title': 'Seguro y Privado',
  'home:whyUs.secure.description': 'Tus archivos se eliminan automáticamente después de la conversión.',
  'home:whyUs.easy.title': 'Fácil de Usar',
  'home:whyUs.easy.description': 'Interfaz simple de arrastrar y soltar, sin habilidades técnicas.',
  'home:whyUs.cta.title': '¿Listo para Comenzar?',
  'home:whyUs.cta.description': 'Únete a millones de usuarios que confían en nuestras herramientas PDF gratuitas.',
  'home:whyUs.cta.button': 'Probar Gratis Ahora',

  'home:testimonials.title': 'Lo Que Dicen los Usuarios',
  'home:testimonials.subtitle': 'Con la confianza de millones de usuarios en todo el mundo.',
  'home:testimonials.trustedBy': 'Confiado y certificado por',
  'home:testimonials.badges.secure': 'SSL Seguro',
  'home:testimonials.badges.verified': 'Verificado Seguro',
  'home:testimonials.badges.award': 'Herramienta Top',
  'home:testimonials.user1.name': 'Sarah Johnson',
  'home:testimonials.user1.role': 'Gerente de Marketing',
  'home:testimonials.user1.content': '¡Esta es la mejor herramienta PDF gratuita que he usado. Rápida, confiable y sin registro molesto!',
  'home:testimonials.user2.name': 'Emily Chen',
  'home:testimonials.user2.role': 'Diseñadora Freelance',
  'home:testimonials.user2.content': 'Convierto PDFs a Word todos los días para mis clientes. ¡Esta herramienta me ahorra mucho tiempo y es completamente gratis!',
  'home:testimonials.user3.name': 'Michael Torres',
  'home:testimonials.user3.role': 'Analista de Negocios',
  'home:testimonials.user3.content': 'La función PDF a Excel es increíblemente precisa. Extrae tablas perfectamente cada vez.',

  'home:ads.topBanner': 'Publicidad',
  'home:ads.middleBanner': 'Publicidad',

  'upload:dragDrop': 'Arrastra y suelta tu archivo PDF aquí',
  'upload:or': 'o',
  'upload:selectFile': 'Seleccionar Archivo',
  'upload:processing': 'Procesando...',
  'upload:converting': 'Convirtiendo tu archivo...',
  'upload:done': '¡Listo!',
  'upload:success': 'Tu archivo ha sido convertido exitosamente',
  'upload:download': 'Descargar Archivo',
  'upload:convertAnother': 'Convertir Otro Archivo',
  'upload:fileSize': 'Tamaño máximo de archivo: 10MB',
  'upload:supportedFormats': 'Formatos compatibles',

  'pdfToWord:title': 'PDF a Word',
  'pdfToWord:description': 'Convierte tus archivos PDF a documentos Word editables gratis',
  'pdfToWord:feature1.title': 'Conversión Rápida',
  'pdfToWord:feature1.desc': 'Convierte PDF a Word en segundos',
  'pdfToWord:feature2.title': 'Alta Calidad',
  'pdfToWord:feature2.desc': 'Preserva el formato y diseño original',
  'pdfToWord:feature3.title': '100% Gratis',
  'pdfToWord:feature3.desc': 'Sin registro ni pago requerido',
  'pdfToWord:howTo.title': 'Cómo Usar',
  'pdfToWord:howTo.step1': 'Sube tu archivo PDF',
  'pdfToWord:howTo.step2': 'Espera la conversión',
  'pdfToWord:howTo.step3': 'Descarga tu archivo Word',

  'pdfToExcel:title': 'PDF a Excel',
  'pdfToExcel:description': 'Convierte tablas PDF a hojas de cálculo Excel editables',
  'pdfToExcel:feature1.title': 'Extraer Tablas',
  'pdfToExcel:feature1.desc': 'Extrae tablas de PDF automáticamente',
  'pdfToExcel:feature2.title': 'Datos Precisos',
  'pdfToExcel:feature2.desc': 'Preserva la estructura de datos original',
  'pdfToExcel:feature3.title': 'Fácil de Usar',
  'pdfToExcel:feature3.desc': 'Interfaz simple e intuitiva',
  'pdfToExcel:howTo.title': 'Cómo Usar',
  'pdfToExcel:howTo.step1': 'Sube archivo PDF con tablas',
  'pdfToExcel:howTo.step2': 'El sistema extraerá las tablas',
  'pdfToExcel:howTo.step3': 'Descarga tu archivo Excel',

  'pdfToPpt:title': 'PDF a PowerPoint',
  'pdfToPpt:description': 'Transforma tu PDF en presentaciones PowerPoint editables',
  'pdfToPpt:feature1.title': 'Conversión de Diapositivas',
  'pdfToPpt:feature1.desc': 'Cada página PDF se convierte en una diapositiva PPT',
  'pdfToPpt:feature2.title': 'Editable',
  'pdfToPpt:feature2.desc': 'Edita texto e imágenes después de la conversión',
  'pdfToPpt:feature3.title': 'Seguro y Privado',
  'pdfToPpt:feature3.desc': 'Tus archivos se eliminan después de la conversión',
  'pdfToPpt:howTo.title': 'Cómo Usar',
  'pdfToPpt:howTo.step1': 'Selecciona tu archivo PDF',
  'pdfToPpt:howTo.step2': 'Convierte a formato PPT',
  'pdfToPpt:howTo.step3': 'Descarga tu presentación',

  'imageConvert:title': 'Convertidor de Imágenes',
  'imageConvert:description': 'Convierte imágenes a PDF o PDF a imágenes fácilmente',
  'imageConvert:feature1.title': 'Multi-Formato',
  'imageConvert:feature1.desc': 'Soporta JPG, PNG, BMP, GIF',
  'imageConvert:feature2.title': 'Conversión por Lotes',
  'imageConvert:feature2.desc': 'Convierte múltiples imágenes a la vez',
  'imageConvert:feature3.title': 'Calidad Preservada',
  'imageConvert:feature3.desc': 'Sin pérdida de calidad de imagen',
  'imageConvert:howTo.title': 'Cómo Usar',
  'imageConvert:howTo.step1': 'Sube imágenes o PDF',
  'imageConvert:howTo.step2': 'Elige el formato de salida',
  'imageConvert:howTo.step3': 'Descarga archivos convertidos',

  'pdfToolsPage:title': 'Herramientas PDF Completas',
  'pdfToolsPage:description': 'Combina, divide, comprime y edita tus archivos PDF',
  'pdfToolsPage:feature1.title': 'Combinar PDF',
  'pdfToolsPage:feature1.desc': 'Combina múltiples PDFs en uno',
  'pdfToolsPage:feature2.title': 'Dividir PDF',
  'pdfToolsPage:feature2.desc': 'Extrae páginas de PDF',
  'pdfToolsPage:feature3.title': 'Comprimir PDF',
  'pdfToolsPage:feature3.desc': 'Reduce el tamaño del archivo PDF',
  'pdfToolsPage:howTo.title': 'Cómo Usar',
  'pdfToolsPage:howTo.step1': 'Elige la herramienta que necesitas',
  'pdfToolsPage:howTo.step2': 'Sube tu archivo PDF',
  'pdfToolsPage:howTo.step3': 'Descarga el resultado procesado',

  'upload.dragDrop': 'Arrastra y suelta tu archivo PDF aquí',
  'upload.or': 'o',
  'upload.selectFile': 'Seleccionar archivo PDF',
  'upload.fileSize': 'Tamaño máximo de archivo: 20MB',
  'upload.uploading': 'Subiendo...',
  'upload.processing': 'Procesando...',
  'upload.converting': 'Convirtiendo...',
  'upload.preparing': 'Preparando descarga...',
  'upload.done': '¡Conversión completada!',
  'upload.download': 'Descargar',
  'upload.convertAnother': 'Convertir otro archivo',
  'upload.convertedTo': 'Convertido a',
  'upload.error': 'Conversión fallida',
  'upload.retry': 'Reintentar',
  'upload.selectAnother': 'Seleccionar otro archivo',
  'upload.fileTooLarge': 'El tamaño del archivo excede el límite de 20MB',
  'upload.invalidFormat': 'Formato de archivo no válido',
  'upload.networkError': 'Error de red, por favor intente de nuevo',
  'upload.conversionFailed': 'Conversión fallida, por favor intente de nuevo',
  'upload.howItWorks': 'Cómo funciona',
  'upload.step1': 'Subir archivo',
  'upload.step1Desc': 'Selecciona o arrastra tu archivo PDF',
  'upload.step2': 'Convertir',
  'upload.step2Desc': 'Procesamos tu archivo automáticamente',
  'upload.step3': 'Descargar',
  'upload.step3Desc': 'Obtén tu archivo convertido al instante',
  'upload.downloading': 'Preparando descarga...',
  'upload.progress': 'Progreso: {percent}%',

  'imageConvert.pdfToImage': 'PDF a Imagen',
  'imageConvert.imageToPdf': 'Imagen a PDF',
  'imageConvert.selectImages': 'Seleccionar Imágenes',
  'imageConvert.multipleFilesHint': 'Admite varias imágenes combinadas en un PDF',
  'imageConvert.processingFiles': 'Procesando {count} archivos...',

  'pdfToPpt.feature1': 'Preservar Diseño',
  'pdfToPpt.feature2': 'Mantener Imágenes',
  'pdfToPpt.feature3': 'Presentación Editable',
};

export default translations;
